/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regionAlign = _interopRequireDefault(require("../../../packages/region-align"));

var _selectParent = _interopRequireDefault(require("../../../common/selectParent"));

function getRegionRelativeToParent(child, prentClassName) {
  var parent = (0, _selectParent.default)(".".concat(prentClassName), child);

  var menuRegion = _regionAlign.default.from(parent);

  var thisRegion = _regionAlign.default.from(child);

  return {
    left: thisRegion.left - menuRegion.left,
    top: thisRegion.top - menuRegion.top,
    width: thisRegion.width,
    height: thisRegion.height
  };
}

var _default = getRegionRelativeToParent;
exports.default = _default;